import { IGetPossibleAppointmentItem } from '../../repositories/announcements/entities/AnnouncementReferences/GetPossibleAppointmentItem';
import { fetchGetPossibleAppointments } from '../../repositories/announcements/v1/get-possible-appointments';
import { mappers } from './mappers';
import { IApplicationContext } from '../../types/application';

export async function getPossibleAppointments(context: IApplicationContext): Promise<IGetPossibleAppointmentItem[]> {
  const { httpApi, logger } = context;

  try {
    return (await fetchGetPossibleAppointments({
      httpApi,
      parameters: {},
      mappers: mappers(context),
    })) as Array<IGetPossibleAppointmentItem>;
  } catch (error) {
    logger.error(error, {
      degradation: "Запрашивался словарь 'Назначение'",
      description: '/v1/get-possible-appointments/ rejection error',
    });

    return Array.of<IGetPossibleAppointmentItem>();
  }
}
